import { render } from "./actions.vue?vue&type=template&id=652663fe&scoped=true"
import script from "./actions.vue?vue&type=script&lang=ts"
export * from "./actions.vue?vue&type=script&lang=ts"

import "./actions.vue?vue&type=style&index=0&id=652663fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-652663fe"

export default script